export enum InitialsTypesEnums {
  SMALL = 'small',
  NORMAL = 'normal',
  LARGE = 'large',
  LARGE_MD = 'large--md',
}
